<template>
  <div>
    <div class="card mobile-header">
      <div class="print">
        <div class="cover-bg">
          <img class="logo" src="../../../assets/db/DB-logo3.svg" />
          <div
            class="goal"
          >
            <h1>
              Indicatieve berekening
              <br /><br />
              {{ goalType }} ({{ goalOfferType }})
            </h1>
            <div
              class="names"
            >
              Naam klant - {{ persoonsData.geslacht
                ? persoonsData.geslacht === 'man' ? 'de heer': 'mevrouw'
                : 'de heer/mevrouw'
              }}
              {{ (persoonsData.roepnaam || persoonsData.voornaam) || '' }}
              {{ persoonsData.tussenvoegsel || '' }}
              {{ persoonsData.achternaam || '' }}
              <br><br>
              Adviseur - {{ advisor || 'Team Doelbeleggen' }}
            </div>
          </div>
          <img class="waves" src="../../../assets/db/cover.svg" />
          <img class="bulls" src="../../../assets/db/goudenstier.svg" />
          <div class="company-info">
            Dorpsstraat&nbsp;34 -<br>
            1182&nbsp;JE&nbsp;Amstelveen<br>
            info@doelbeleggen.nl<br>
            020&nbsp;555&nbsp;0055
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    advisor: String,
    goalData: Object,
    persoonsData: Object,
  },
  computed: {
    goalOfferType() {
      if (this.goalData.type === 'gouden-handdruk-uitkerend'
        || this.goalData.type === 'netto-lijfrente-uitkerend'
        || (this.goalData.type === 'levensonderhoud' && Number(this.goalData.box) === 1)
      ) {
        return 'uitkerend';
      }
      return 'opbouwend';
    },
    goalType() {
      if (this.goalData.type === 'gouden-handdruk-opbouwend' || this.goalData.type === 'gouden-handdruk-uitkerend') {
        return 'Gouden handdruk';
      }
      if (this.goalData.type === 'netto-lijfrente-uitkerend') {
        return 'Netto lijfrente';
      }
      return 'Lijfrente';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../scss/_paper.scss";
  .cover-bg {
    background-color: #242756;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    @media print {
      width: 103%;
    }
  }
  .logo {
    transform:scale(0.4);
    width: 100%;
    margin: 25% auto 2% auto;
  }
  .goal {
    h1 {
      text-transform: uppercase;
      font-size: 25px;
      @media #{$mobile} {
      line-height: 150%;
      }
    }
    color: white;
    width: max-content;
    margin: auto;
    @media #{$mobile} {
      width: 75%;
    }
  }
  .names {
    margin-top: 20px;
    text-align: left;
    color: white;
    font-size: 15px;
  }
  .bulls {
    transform: scale(0.35);
    position: absolute;
    bottom: 20%;
  }
  .company-info {
    text-transform: uppercase;
    text-align: center;
    color: white;
    font-size: 15px;
    position: absolute;
    bottom: 11%;
    left: 39%;
  }
  .waves {
    width: 110%;
    transform: scale(1.8);
    position: absolute;
    bottom: 16%;
  }
  @media #{$mobile} {
    .mobile-header {
      height: 90vh;
      .cover-bg {
        .company-info {
          bottom: 10%;
          left: 0;
          text-align: center;
          width: 100%;
        }
        .waves {
          bottom: 12%;
        }
      }
    }
  }
</style>
